export const defaultColumn = [
  {
    id: 'image',
    fieldName: 'image',
    label: 'Image',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 0,
    class: 'list_image',
    content: false,
  },
  {
    id: 'blitzId',
    fieldName: 'blitzId',
    label: 'Blitz Id',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 1,
    class: 'list_asset_id',
    content: true,
  },
  {
    id: 'contentId',
    fieldName: 'contentId',
    label: 'Content Id',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 2,
    class: 'list_asset_id',
    content: true,
  },
  {
    id: 'legacyHouseId',
    fieldName: 'legacyHouseId',
    label: 'Partner Content Id',
    sort: true,
    filter: false,
    viewInListing: false,
    position: 3,
    content: true,
  },
  {
    id: 'state',
    fieldName: 'state',
    label: 'Asset State',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 6,
    content: true,
  },
  {
    id: 'assetType',
    fieldName: 'assetType',
    label: 'Asset Type',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 7,
    content: true,
  },
  {
    id: 'assetCategory',
    fieldName: 'assetCategory',
    label: 'Asset Category',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 8,
    content: true,
  },
  {
    id: 'contentCategory',
    fieldName: 'contentCategory',
    label: 'Content Category',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 9,
    content: true,
  },
  {
    id: 'firstCreatedOn',
    fieldName: 'firstCreatedOn',
    label: 'Creation Date',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 16,
    fieldType: 'DATETIME',
    content: true,
  },
  {
    id: 'serviceAlias',
    fieldName: 'serviceAlias',
    label: 'Partner',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 17,
    content: true,
  },
]

export const entitlementProperties = [
  {
    id: 'image',
    fieldName: 'image',
    label: 'Image',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 0,
    class: 'list_image',
    content: false,
  },
  {
    id: 'blitzId',
    fieldName: 'blitzId',
    label: 'Blitz Id',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 1,
    class: 'list_asset_id',
    content: true,
  },
  {
    id: 'contentId',
    fieldName: 'contentId',
    label: 'Content Id',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 2,
    class: 'list_asset_id',
    content: true,
  },
  {
    id: 'state',
    fieldName: 'state',
    label: 'Asset State',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 3,
    content: true,
  },
  {
    id: 'metaAttributes.assetTitle',
    label: 'Title',
    dataType: 'STRING',
    fieldType: 'TEXT',
    fieldName: 'assetTitle',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 4,
  },
  {
    id: 'metaAttributes.episodeTitle',
    label: 'Asset Title',
    dataType: 'STRING',
    fieldType: 'TEXT',
    fieldName: 'episodeTitle',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 5,
  },
  {
    id: 'assetType',
    fieldName: 'assetType',
    label: 'Asset Type',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 6,
    content: true,
  },
  {
    id: 'assetCategory',
    fieldName: 'assetCategory',
    label: 'Asset Category',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 7,
    content: true,
  },
  {
    id: 'contentCategory',
    fieldName: 'contentCategory',
    label: 'Content Category',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 8,
    content: true,
  },
  {
    id: 'metaAttributes.season',
    label: 'Season Number',
    dataType: 'NUMBER',
    fieldType: 'NUMBER',
    fieldName: 'season',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 9,
  },
  {
    id: 'metaAttributes.episodeNumber',
    label: 'Episode Number',
    dataType: 'NUMBER',
    fieldType: 'NUMBER',
    fieldName: 'episodeNumber',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 10,
  },
]
